import React, {
  useCallback,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";

// API
import { templateLists } from "../../../modules/channels/api/Api";

// assets
import VideoSvg from "assets/customSVG/VideoSvg";
import { ICONS } from "assets/icons";

// helper
import { capitalizeFirstLetter } from "helper/capitalizeFirstLetter";
import { getLanguageName } from "helper/setLanguageCode";

// utils
import InfiniteScroll from "react-infinite-scroll-component";

// redux
import { useAspDispatch, useAspSelector } from "../../../test/jest-redux-hooks";

// hooks
import { useTemplateVariables } from "hooks/templates/useTemplateVariables";
import { useFileUploader } from "hooks/useFileUploader";
import { useSearch } from "hooks/useSearch";
import useToggle from "hooks/useToggle";

// reducers
// import {
//   INITIAL_STATE,
//   templateReducer,
// } from "hooks/templates/templateReducers";

// components
import { Popover } from "antd";
import NoData from "components/commonComponents/Nodata/index";
import { useLocation } from "react-router-dom";
import { creditsApi } from "../../../api/Api";
import { getProducts } from "../../../modules/products/api/api";
import { cn } from "../../../helper/cn";
import {
  INITIAL_STATE,
  templateReducer,
} from "../../../modules/channels/reducers/templateReducer";
import { CATEGORY_TYPE_INBOX } from "../../../modules/inbox/constants";
import CheckBoxSqure from "../checkbox/CheckBoxSqure";
import Loader from "../Loader/Index";
import SearchBar from "../searchBar";
import TemplateCard from "./TemplateCard";
import TemplatePreview from "./TemplatePreview";
import VariablesPreviewCard from "./VariablesPreviewCard";

let limit = 10;
let count = 0;
let page = 1;

export default function TemplateListContainer({
  isSending,
  className,
  sendTemplate,
  changeMedia = true,
  changeVariable = true,
  previewSelect,
  open,
  setSelectTemplate,
  setOpenTemplateList,
}) {
  const { currentBrand } = useAspSelector((state) => state?.app);
  const dispatch = useAspDispatch();

  const inputRef = useRef();

  const { uploading, selectedFile, setSelectedFile, uploadFiles, error } =
    useFileUploader();

  const [loading, setLoading] = useToggle(true);
  const [isLoadingNextPage, setIsLoadingNextPage] = useToggle(false);
  const { searchKey, setSearchKey, onChange: onSearch } = useSearch("");
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [products, setProducts] = useState([{ id: '', quantity: 1, image_url: '' }]);
  const [availableProducts, setAvailableProducts] = useState([]);
  const [orderDetails, setOrderDetails] = useState({
    discount: 0,
    discount_type: 'percent',
    discount_description: '',
    shipping: 0,
    shipping_description: '',
    tax: 0,
    tax_type: 'tax_exclusive',
    tax_description: '',
    goods_type: 'digital-goods'
  });
  const [selectedCard, setSelectedCard] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [cards, setCards] = useState([]);
  const [categoryChange, setCategoryChange] = useState(null);
  const [categoryId, setCategoryId] = useState(null);

  const templateListContainerRef = useRef(null);
  const location = useLocation();
  const [credits, setCredits] = useState([]);

  // selected template
  const [useTemplates, setUseTemplates] = useToggle(false);

  const { variables, updateVariables, getVariablesFromStr } =
    useTemplateVariables();

  const [templateData, templateDispatch] = useReducer(
    templateReducer,
    INITIAL_STATE
  );

  const { id, custom, authentication, carousel } = templateData;

  const {
    header,
    headerVariable,
    body,
    bodyVariables,
    footer,
    buttons,
    buttonsOrder,
    ctaButtons,
    customButtons,
  } = custom;

  const allvariables = useCallback(() => {
    let variables = [];

    if (bodyVariables?.length > 0) variables = [...variables, ...bodyVariables];

    if (carousel?.bodyVariables?.length > 0)
      variables = [...variables, ...carousel?.bodyVariables];

    return variables;
  }, [bodyVariables, carousel]);

  useEffect(() => {
    setCategoryChange(CATEGORY_TYPE_INBOX);
  }, []);

  useEffect(() => {
    if (location.pathname.startsWith("/user")) {
      creditsApi(currentBrand?.brand_id).then((res) => {
        if (res?.status === 200) {
          setCredits(res?.data?.brand_credits);
        }
      });
    }
  }, []);

  useEffect(() => {
    page = 1;
    if (limit > 0)
      fetchTemplateLists(true, currentBrand?.brand_id, {
        page: page,
        limit: limit,
        name: searchKey,
        status: "ACTIVE",
        category: categoryId && categoryId.length > 0 ? categoryId : [2, 3],
      });
  }, [currentBrand, categoryId]);

  useEffect(() => {
    const timeOut = setTimeout(() => {
      page = 1;
      if (limit > 0)
        fetchTemplateLists(true, currentBrand?.brand_id, {
          page: page,
          limit: limit,
          name: searchKey,
          status: "ACTIVE",
          category: categoryId && categoryId.length > 0 ? categoryId : [2, 3],
        });
    }, 500);

    return () => clearTimeout(timeOut);
  }, [searchKey]);

  useEffect(() => {
    templateDispatch({
      type: "update_template",
      data: selectedTemplate,
    });
  }, [selectedTemplate]);

  useEffect(() => {
    setCards(carousel?.cards);
  }, [carousel?.cards]);

  const fetchTemplateLists = async (load, brandId, payload) => {
    if (brandId) {
      if (load) setLoading(true);
      if (!load) setIsLoadingNextPage(true);

      await templateLists(brandId, payload)
        .then((res) => {
          if (res && res.data?.templates?.length > 0) {
            if (page === 1) setTemplates(res?.data?.templates);
            else
              setTemplates([
                ...new Set([...templates, ...res?.data?.templates]),
              ]);
            count = res?.data?.template_count;
          } else {
            setTemplates([]);
          }
        })
        .finally(() => {
          if (load) setLoading(false);
          if (!load) setIsLoadingNextPage(false);
        });
    } else {
      setTemplates([]);
    }
  };

  const onCategoryChange = (values) => {
    const updatedCategory = categoryChange.map((item) => {
      if (item?.id === values?.id) {
        return { ...item, isSelected: !item?.isSelected }; // Toggle isSelected
      }
      return item;
    });
    const filterValues = updatedCategory?.filter(
      (item) => item?.isSelected === true && item.id
    );
    // Extracting only `id`
    const ids = filterValues?.map((item) => item?.category_id);

    setCategoryId(ids);

    setCategoryChange(updatedCategory);
  };

  const clearType = () => {
    const res = categoryChange?.map((t) => {
      return { ...t, isSelected: false };
    });

    setCategoryChange(res);
    setCategoryId([2, 3]);
  };

  const loadNextPage = () => {
    page += 1;
    fetchTemplateLists(false, currentBrand?.brand_id, {
      page: page,
      limit: limit,
      name: searchKey,
      status: "ACTIVE",
      category: categoryId && categoryId.length > 0 ? categoryId : [2, 3],
    });
  };

  const updateTemplate = (type, key, value) => {
    if (selectedTemplate)
      if (["HEADER", "BODY", "FOOTER", "BUTTONS"].includes(type)) {
        const filterType = selectedTemplate?.components?.filter(
          (c) => c.type === type
        );

        const filterWithoutType = selectedTemplate?.components?.filter(
          (c) => c.type !== type
        );

        const updatedData = {
          ...selectedTemplate,
          components: [
            ...filterWithoutType,
            {
              ...filterType?.[0],
              [key]: value,
            },
          ],
        };
        setSelectedTemplate(updatedData);
      } else {
        setSelectedTemplate({ ...selectedTemplate, [key]: value });
      }
  };

  // get the file name from media file
  const fileName = (url) => {
    const names = url?.split("/");
    return names?.[names.length - 1];
  };

  const errorStyle = "text-[var(--fontRed)] font-md weight-400 my-[0.5vw]";

  const onDataChange = ({
    type,
    primaryKey,
    secondaryKey,
    updateKey,
    id,
    key,
    value,
    text,
    data,
  }) => {
    const payload = {
      type: type,
      key: key,
      value: value,
    };

    if (primaryKey) payload["primaryKey"] = primaryKey;
    if (secondaryKey) payload["secondaryKey"] = secondaryKey;
    if (updateKey) payload["updateKey"] = updateKey;
    if (id) payload["id"] = id;
    if (text) payload["text"] = text;
    if (data) payload["data"] = data;

    templateDispatch(payload);
  };

  const currentCategory = useCallback(() => {
    return templateData?.categoryType;
  }, [templateData]);

  // const creditsLow = useCallback(() => {
  //   return (
  //     templateData?.category === "MARKETING" && credits?.total_credits < 500
  //   );
  // }, [templateData, credits]);

  const handleProductChange = (index, field, value) => {
    const updatedProducts = [...products];

    // If updating quantity, ensure it's a valid number between 1 and 100
    if (field === 'quantity') {
      const numValue = parseInt(value, 10) || 1;
      updatedProducts[index] = {
        ...updatedProducts[index],
        [field]: Math.max(1, Math.min(100, numValue))
      };
    } else {
      updatedProducts[index] = { ...updatedProducts[index], [field]: value };
    }

    setProducts(updatedProducts);
  };

  // Handle product selection from dropdown
  const handleProductSelect = (index, productId) => {

    if (productId) {
      // Check if this product is already selected in another row
      const isProductAlreadySelected = products.some((product, i) =>
        i !== index && product.id == productId
      );

      if (isProductAlreadySelected) {
        // Reset the current selection
        const updatedProducts = [...products];
        updatedProducts[index] = {
          ...updatedProducts[index],
          id: '',
          name: '',
          price: 0,
          image_url: '',
        };
        setProducts(updatedProducts);

        // Show error message or alert
        showErrorToast(notification, "Product already selected, select another product");
        return;
      }

      const selectedProduct = availableProducts.find(p => {
        return p.id == productId; // Use loose equality to handle string/number mismatches
      });

      if (!selectedProduct) {
        console.error('Product not found. Available product IDs:', availableProducts.map(p => ({ id: p.id, type: typeof p.id })));
      }

      if (selectedProduct) {
        const updatedProducts = [...products];
        updatedProducts[index] = {
          ...updatedProducts[index],
          id: selectedProduct.id,
          name: selectedProduct.name || '',
          price: selectedProduct.price || 0,
          quantity: updatedProducts[index]?.quantity || 1, // Keep existing quantity or default to 1
          image_url: selectedProduct.image_url || '',
        };

        setProducts(updatedProducts);
      }
    } else {
      // If productId is empty, reset the product
      const updatedProducts = [...products];
      updatedProducts[index] = {
        id: '',
        name: '',
        price: 0,
        quantity: 1,
        image_url: ''
      };
      setProducts(updatedProducts);
    }
  };

  // Handle adding a new product
  const handleAddProduct = () => {
    setProducts([...products, {
      id: '',
      name: '',
      quantity: 1,
      price: 0,
      image_url: ''
    }]);
  };

  // Handle product removal
  const handleRemoveProduct = (index) => {
    if (products.length > 1) {
      const updatedProducts = [...products];
      updatedProducts.splice(index, 1);
      setProducts(updatedProducts);
    }
  };

  const handleOrderDetailChange = (field, value) => {
    setOrderDetails(prev => ({
      ...prev,
      [field]: value
    }));
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await getProducts(currentBrand?.brand_id);
        setAvailableProducts(response?.data?.products || []);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
    fetchProducts();
  }, []);

  return (
    <div className="w-full h-full min-h-[70vh] max-h-[73vh] p-[1.5vw]">
      <div className="flex items-center justify-between mb-[1vw]">
        {useTemplates ? (
          <div className="flex items-center gap-[0.6vw]">
            <button
              className="cursor-pointer"
              onClick={() => {
                setUseTemplates(false);
                setSelectedFile(null);
              }}
            >
              <img
                src={ICONS?.backArrow}
                alt="back icons"
                className="size-[1.5vw] mt-1"
              />
            </button>
            <p className="main-header2">{selectedTemplate?.name}</p>
            <p
              className={`px-[0.6vw] py-[0.2vw] rounded-[0.25vw]
              ${
                selectedTemplate?.category === "MARKETING"
                  ? "marketing-title"
                  : "utility-title"
              }`}
            >
              {capitalizeFirstLetter(selectedTemplate?.category)}
            </p>
            <p
              className={`px-[0.6vw] py-[0.2vw] language-title  rounded-[0.25vw] bg-[#E7F4FC] text-[var(--dashboardprimary)]`}
            >
              {getLanguageName(selectedTemplate?.language)}
            </p>
          </div>
        ) : (
          <div className="w-100 flex-row align-center gap-3 space-between">
            <h4 className="new-header3">
              {`${count || 0} Existing templates`}
            </h4>

            <div className="flex-row align-center gap-2.5">
              <SearchBar
                searchKey={searchKey}
                setSearchKey={setSearchKey}
                // className="!w-[15vw]"
                onChange={(val) => {
                  onSearch(val);
                }}
                search="search-template"
                searchCancel="searchCancel"
                expandable={true}
              />

              <Popover
                trigger={["click"]}
                placement="bottom"
                arrow={false}
                content={
                  <div className="min-w-56 px-3.5 py-2.5">
                    <div className="w-full h-8 flex items-center justify-between gap-5 py-2.5 new-left-layout">
                      <div className="text-[var(--font-400)]">Type</div>
                      <div
                        className={cn(
                          "text-[#F96056]",
                          categoryId?.length > 0
                            ? "cursor-pointer opacity-100"
                            : "cursor-not-allowed opacity-50"
                        )}
                        onClick={() => {
                          if (categoryId?.length > 0) clearType();
                        }}
                      >
                        Clear
                      </div>
                    </div>
                    {categoryChange?.map((s) => {
                      return (
                        <div
                          className={cn(
                            "w-full h-9 flex items-center gap-2.5 py-1 cursor-pointer new-body-text p-10 mt-10"
                          )}
                          onClick={() => {
                            onCategoryChange(s);
                          }}
                          key={s?.id}
                        >
                          <CheckBoxSqure
                            value={s?.isSelected}
                            onChange={() => {
                              // Optionally handle checkbox changes directly
                            }}
                            className="size-4"
                          />
                          {s?.icon && (
                            <img src={s?.icon} alt={s.label} className="w-4" />
                          )}
                          <p>{s?.label}</p>
                        </div>
                      );
                    })}
                  </div>
                }
              >
                <div className="group/sort flex items-center gap-2.5 bg-[var(--BG-25)] px-3 py-1.5 rounded-[0.4vw] cursor-pointer">
                  <div className="campaign-filters">{"Category (All)"}</div>
                  <div
                    className={cn(
                      "transition-transform duration-200 ease-linear",
                      // group-hover/sort:-rotate-180,
                      false ? "-rotate-180" : "rotate-0"
                      // isLoading ? "cursor-not-allowed" : "cursor-pointer"
                    )}
                  >
                    <div
                      className={`border-[0.4vw] rounded-t-[0.2vw] border-transparent border-t-[#777] translate-y-[25%]`}
                    ></div>
                  </div>
                </div>
              </Popover>
            </div>
          </div>
        )}
      </div>
      {loading && (
        <div className="w-full h-full min-h-[50vh] max-h-[73vh] flex items-center justify-center">
          <Loader Width={30} Height={30} loaderBg="white" />
        </div>
      )}
      {!loading && (
        <div className="">
          <div className="min-w-full flex gap-[1vw]">
            <div className="w-full h-[58vh] pr-[0.2vw] !flex-row align-center">
              {useTemplates ? (
                <div className="w-full flex-row space-between">
                  {/* Variable, Media and Products */}
                  <div className="w-60">
                    <div className="w-full max-h-[58vh] px-[0.5vw] overflow-auto">

                      {/* Media */}
                      <div className="w-full h-[15vh] pt-[1vw] border-t-[0.08vw] border-[var(--border-50)]">
                        <h3 className="new-header3">Select Media File</h3>
                        <p className="sidebar-sub-header-font-400 mt-[0.3vw]">
                          Upload a media for this template
                        </p>
                        {currentCategory() === "CAROUSEL" ? (
                          <div className="w-full flex items-center gap-5 mt-10 overflow-x-xscroll">
                            {carousel?.cards?.map((c) => {
                              const header = c?.components?.filter(
                                (com) => com.type === "HEADER"
                              );

                              return (
                                <div
                                  className="relative size-20 rounded-md pointer carousel-image-hover"
                                  onClick={() => {
                                    setSelectedCard(c);
                                  }}
                                >
                                  {header?.[0]?.format === "IMAGE" && (
                                    <img
                                      src={
                                        c?.image ||
                                        header?.[0]?.example?.header_handle
                                      }
                                      alt="card images"
                                      className="size-20 rounded-md"
                                    />
                                  )}
                                  {header?.[0]?.format === "VIDEO" && (
                                    <video
                                      className="w-full h-full object-cover rounded-[0.4vw]"
                                      // controls
                                      // autoplay='autoplay'
                                      loop
                                    >
                                      <source
                                        src={
                                          c?.image ||
                                          header?.[0]?.example?.header_handle
                                        }
                                        type="video/mp4"
                                      />
                                    </video>
                                  )}
                                  <span
                                    className="absolute top-0.5 right-0.5 bg-white text-[var(--contentText)] font-medium weight-semibold rounded-md px-0.5"
                                    onClick={() => {
                                      if (isSending) return;
                                      inputRef.current.value = null;
                                      inputRef?.current?.click();
                                    }}
                                  >
                                    <img
                                      src={ICONS?.carouselEdit}
                                      alt="carouselEdit"
                                    />
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        ) : ["IMAGE", "VIDEO", "DOCUMENT"]?.includes(
                            header?.format
                          ) ? (
                          <div className="mt-[0.7vw]">
                            <div className="flex items-center gap-[0.8vw]">
                              <div>
                                {header?.format === "IMAGE" && (
                                  <img
                                    src={header?.example?.header_handle?.[0]}
                                    alt="preview images"
                                    className="size-[4vw] font-xs weight-medium rounded-[0.5vw]"
                                  />
                                )}
                                {header?.format === "VIDEO" && (
                                  <div className="h-[4vw] flex items-center gap-[0.3vw] bg-[var(--primary)] px-[0.5vw] py-[0.1.5vw] rounded-[0.5vw] cursor-pointer">
                                    <VideoSvg
                                      color="var(--white)"
                                      width={"3vw"}
                                      height={"3vw"}
                                    />
                                  </div>
                                )}
                                {header?.format === "DOCUMENT" && (
                                  <iframe
                                    title="cover"
                                    src={header?.example?.header_handle?.[0]}
                                    type="application/pdf"
                                    width="100%"
                                    height="100px"
                                  ></iframe>
                                )}
                              </div>
                              <div className="w-full">
                                <p className="w-3/4 new-header2 truncate">
                                  {selectedFile
                                    ? selectedFile?.name
                                    : fileName(
                                        header?.example?.header_handle?.[0]
                                      )}
                                </p>
                                {changeMedia && (
                                  <button className="w-[7vw] change-media-title  px-[0.6vw] py-[0.4vw] rounded-[0.37vw] mt-[0.4vw]">
                                    <div className="flex items-center justify-center">
                                      <input
                                        type="file"
                                        disabled={isSending}
                                        accept={
                                          header?.format === "IMAGE"
                                            ? ".jpg, .png"
                                            : header?.format === "VIDEO"
                                            ? ".mp4"
                                            : header?.format === "DOCUMENT" &&
                                              ".pdf"
                                        }
                                        onChange={async (e) => {
                                          const res = await uploadFiles(
                                            e,
                                            header?.format
                                          );

                                          onDataChange({
                                            type: "header",
                                            updateKey: "mediaUrl",
                                            value: res,
                                          });
                                        }}
                                        id="uploadImg"
                                        hidden
                                      />

                                      <label
                                        for="uploadImg"
                                        className="w-full flex-center"
                                      >
                                        {uploading ? (
                                          <Loader
                                            Width={20}
                                            Height={20}
                                            loaderBg="white"
                                          />
                                        ) : (
                                          <div className="">Choose media</div>
                                        )}
                                      </label>
                                    </div>
                                  </button>
                                )}
                              </div>
                            </div>

                            <>
                              {header?.format === "IMAGE" && error && (
                                <div className={`${errorStyle}`}>
                                  Image size should be less than 5MB
                                </div>
                              )}

                              {header?.format === "VIDEO" && error && (
                                <div className={`${errorStyle}`}>
                                  Video size should be less than 16MB
                                </div>
                              )}

                              {header?.format === "DOCUMENT" && error && (
                                <div className={`${errorStyle}`}>
                                  Document size should be less than 100MB
                                </div>
                              )}
                            </>
                          </div>
                        ) : (
                          <div className="w-full h-[10vh] flex-center sidebar-sub-header-font-400">
                            No media files found on this template.
                          </div>
                        )}
                      </div>

                      {/* Variable */}
                      <div className="pt-10">
                        <div className="w-full flex items-center gap-[1vw] py-[0.5vw] border-b-[0.08vw] border-[var(--border-50)]">
                          <div className="w-[40%] popover-title">Variable</div>
                          <div className="w-[60%] popover-title">
                            Add variable content
                          </div>
                        </div>
                        {allvariables()?.length > 0 ? (
                          <div className="w-full py-[0.5vw] overflow-y-scroll listScroll ">
                            {allvariables()?.map((v) => {
                              return (
                                <div>
                                  <VariablesPreviewCard
                                    key={v?.id}
                                    data={v}
                                    className={"h-[6.7vh] pr-[0.5vw]"}
                                    changeVariableText={changeVariable}
                                    onChange={(value) => {
                                      if (currentCategory() === "CAROUSEL") {
                                        onDataChange({
                                          type: "update_bodyVariables",
                                          updateKey: "carousel",
                                          // id: data?.id,
                                          key: value?.key,
                                          value: value?.value,
                                          // text: value?.text,
                                        });
                                      } else {
                                        onDataChange({
                                          type: "update_variable",
                                          key: value?.key,
                                          value: value.value,
                                        });
                                      }
                                    }}
                                    isSending={isSending}
                                  />
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <div className="w-full h-[15vh] flex-center new-header2">
                            No variables found on this template.
                          </div>
                        )}
                      </div>
                      {/* Order Details - Only show for ORDER_DETAIL template type */}
                      {selectedTemplate?.subcategory_type === 'ORDER_DETAIL' && (
                      <div className="w-full pt-4 border-t border-gray-200">
                        <h3 className="text-base font-medium text-gray-800 mb-3">Order Details</h3>

                        {products.map((product, index) => (
                          <div key={product.id || index} className="space-y-3 p-3 bg-white rounded border border-gray-200 mb-3">
                            <div className="flex items-end gap-3">
                              {/* Product Selection */}
                              <div className="flex-1">
                                <label className="text-xs text-gray-500 block mb-1">Product</label>
                                <select
                                  value={product.id || ''}
                                  onChange={(e) => handleProductSelect(index, e.target.value)}
                                  className="w-full text-sm p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                >
                                  <option value="">Select a product</option>
                                  {availableProducts.map((prod) => (
                                    <option key={prod.id} value={prod.id}>
                                      {prod.name} (₹{prod.price ? parseFloat(prod.price).toFixed(2) : '0.00'})
                                    </option>
                                  ))}
                                </select>
                              </div>

                              {/* Price (Read-only) */}
                              <div className="w-32">
                                <label className="text-xs text-gray-500 block mb-1">Price (₹)</label>
                                <div className="relative">
                                  <span className="absolute left-2 top-2 text-gray-400 text-sm">₹</span>
                                  <input
                                    type="text"
                                    value={product.price ? (parseFloat(product.price) * (product.quantity || 1)).toFixed(2) : '0.00'}
                                    readOnly
                                    className="w-full text-sm p-2 pl-6 border border-gray-200 bg-gray-50 rounded-md"
                                  />
                                </div>
                              </div>

                              {/* Quantity */}
                              <div className="w-24">
                                <label className="text-xs text-gray-500 block mb-1">Quantity</label>
                                <div className="flex items-center border border-gray-300 rounded-md overflow-hidden">
                                  <button
                                    type="button"
                                    onClick={() => {
                                      const currentQty = parseInt(product.quantity, 10) || 1;
                                      const newQuantity = Math.max(1, currentQty - 1);
                                      handleProductChange(index, 'quantity', newQuantity);
                                    }}
                                    className="px-2 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700 focus:outline-none"
                                    disabled={!product.id}
                                  >
                                    -
                                  </button>
                                  <input
                                    type="number"
                                    min="1"
                                    max="100"
                                    value={product.quantity || ''}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (value === '') {
                                        handleProductChange(index, 'quantity', '');
                                      } else {
                                        const numValue = parseInt(value, 10);
                                        if (!isNaN(numValue)) {
                                          handleProductChange(index, 'quantity', Math.max(1, Math.min(100, numValue)));
                                        }
                                      }
                                    }}
                                    onKeyDown={(e) => {
                                      if (['-', 'e', 'E', '+', '.'].includes(e.key)) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onBlur={(e) => {
                                      if (!e.target.value) {
                                        handleProductChange(index, 'quantity', 1);
                                      }
                                    }}
                                    className="w-full text-sm p-2 border-0 text-center focus:ring-1 focus:ring-blue-500"
                                    disabled={!product.id}
                                  />
                                  <button
                                    type="button"
                                    onClick={() => {
                                      const currentQty = parseInt(product.quantity, 10) || 0;
                                      const newQuantity = Math.min(100, currentQty + 1);
                                      handleProductChange(index, 'quantity', newQuantity);
                                    }}
                                    className="px-2 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700 focus:outline-none"
                                    disabled={!product.id}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>

                              {/* Remove button */}
                              {products.length > 1 && (
                                <button
                                  type="button"
                                  onClick={() => handleRemoveProduct(index)}
                                  className="mb-1 p-1 hover:bg-gray-100 rounded text-red-500"
                                >
                                  ✕
                                </button>
                              )}
                            </div>
                          </div>
                        ))}

                        {/* Add Product Button */}
                        <div className="flex justify-between mt-4">
                          <button
                            type="button"
                            onClick={handleAddProduct}
                            className="text-sm text-blue-600 hover:text-blue-800 flex items-center gap-1 px-3 py-1.5 border border-blue-200 rounded-md hover:bg-blue-50"
                            disabled={products.length >= 5}
                            title={products.length >= 5 ? 'Maximum 5 products allowed' : 'Add another product'}
                          >
                            <span className="text-lg">+</span> Add Product
                          </button>
                          <div className="text-xs text-gray-500 self-center">
                            {products.length}/5 products added
                          </div>
                        </div>

                        {/* Order Summary */}
                        <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                          <h3 className="text-sm font-medium text-gray-700 mb-3">Order Summary</h3>

                          {/* Goods Type */}
                          <div className="mb-4">
                            <label className="text-xs text-gray-500 block mb-1">Goods Type</label>
                            <select
                              value={orderDetails.goods_type}
                              onChange={(e) => handleOrderDetailChange('goods_type', e.target.value)}
                              className="w-full max-w-xs text-sm p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                            >
                              <option value="physical-goods">Physical goods</option>
                              <option value="digital-goods">Digital goods</option>
                            </select>
                          </div>

                          {/* Discount Section */}
                          <div className="mb-4 p-4 border border-gray-200 rounded-md">
                            <div className="flex justify-between items-center mb-3">
                              <label className="text-sm font-medium text-gray-700">Discount</label>
                              <div className="flex items-center gap-2">
                                <span className="text-xs text-gray-500">Type:</span>
                                <select
                                  value={orderDetails.discount_type || 'percent'}
                                  onChange={(e) => handleOrderDetailChange('discount_type', e.target.value)}
                                  className="text-xs border border-gray-300 rounded p-1"
                                >
                                  <option value="percent">Percentage</option>
                                  <option value="fixed">Fixed Amount</option>
                                </select>
                              </div>
                            </div>
                            <div className="relative mb-2">
                              <span className="absolute left-2 top-2 text-gray-400 text-sm">
                                {orderDetails.discount_type === 'percent' ? '%' : '₹'}
                              </span>
                              <input
                                type="number"
                                min="0"
                                max={orderDetails.discount_type === 'percent' ? '100' : undefined}
                                step={orderDetails.discount_type === 'percent' ? '1' : '1.00'}
                                value={orderDetails.discount ?? ''}
                                onChange={(e) => {
                                  const value = e.target.value === '' ? '' : parseFloat(e.target.value);
                                  handleOrderDetailChange('discount', isNaN(value) ? '' : value);
                                }}
                                onBlur={(e) => {
                                  if (e.target.value === '') {
                                    handleOrderDetailChange('discount', 0);
                                  }
                                }}
                                className="w-full text-sm p-2 pl-8 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                placeholder={orderDetails.discount_type === 'percent' ? '0' : '0.00'}
                              />
                              {orderDetails.discount_type === 'percent' && (
                                <div className="flex gap-2 mt-2">
                                  {[5, 10, 15, 20].map(percent => (
                                    <button
                                      key={percent}
                                      type="button"
                                      onClick={() => handleOrderDetailChange('discount', percent)}
                                      className={`text-xs px-2 py-1 rounded ${
                                        orderDetails.discount === percent
                                          ? 'bg-blue-100 text-blue-700'
                                          : 'bg-gray-100 hover:bg-gray-200'
                                      }`}
                                    >
                                      {percent}%
                                    </button>
                                  ))}
                                </div>
                              )}
                              <div className="relative mt-2">
                                <input
                                  type="text"
                                  value={orderDetails.discount_description || ''}
                                  onChange={(e) => {
                                    if (e.target.value.length <= 60) {
                                      handleOrderDetailChange('discount_description', e.target.value);
                                    }
                                  }}
                                  maxLength={60}
                                  className="w-full text-xs pr-12 py-2 pl-2 border border-gray-200 rounded focus:outline-none focus:ring-1 focus:ring-blue-200"
                                  placeholder="Description (optional)"
                                />
                                <div className="absolute right-2 top-1/2 transform -translate-y-1/2 text-xs text-gray-400 bg-white px-1">
                                  {orderDetails.discount_description?.length || 0}/60
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Shipping Section */}
                          <div className="mb-4 p-4 border border-gray-200 rounded-md">
                            <label className="text-sm font-medium text-gray-700 block mb-3">Shipping</label>
                            <div className="relative mb-2">
                              <span className="absolute left-2 top-2 text-gray-400 text-sm">₹</span>
                              <input
                                type="number"
                                min="0"
                                step="1.00"
                                value={orderDetails.shipping || ''}
                                onChange={(e) => handleOrderDetailChange('shipping', parseFloat(e.target.value) || 0)}
                                className="w-full text-sm p-2 pl-6 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                placeholder="0.00"
                              />
                            </div>
                            <div className="relative">
                              <input
                                type="text"
                                value={orderDetails.shipping_description || ''}
                                onChange={(e) => {
                                  if (e.target.value.length <= 60) {
                                    handleOrderDetailChange('shipping_description', e.target.value);
                                  }
                                }}
                                maxLength={60}
                                className="w-full text-xs pr-10 py-2 pl-4 border border-gray-200 rounded focus:outline-none focus:ring-1 focus:ring-blue-200 mt-2"
                                placeholder="Description (optional)"
                              />
                              <div className="absolute right-2 bottom-1 text-xs text-gray-400">
                                {orderDetails.shipping_description?.length || 0}/60
                              </div>
                            </div>
                          </div>

                          {/* Tax Section */}
                          <div className="mb-4 p-4 border border-gray-200 rounded-md">
                            <div className="flex justify-between items-center mb-3">
                              <label className="text-sm font-medium text-gray-700">Tax</label>
                              <div className="flex items-center gap-2">
                                <span className="text-xs text-gray-500">Type:</span>
                                <select
                                  value={orderDetails.tax_type || 'tax_inclusive'}
                                  onChange={(e) => handleOrderDetailChange('tax_type', e.target.value)}
                                  className="text-xs border border-gray-300 rounded p-1"
                                >
                                  <option value="tax_inclusive">Tax Inclusive</option>
                                  <option value="tax_exclusive">Tax Exclusive</option>
                                </select>
                              </div>
                            </div>
                            <div className="relative mb-2">
                              <span className="absolute left-2 top-2 text-gray-400 text-sm">
                                %
                              </span>
                              <input
                                type="number"
                                min="0"
                                step="1"
                                value={orderDetails.tax || ''}
                                onChange={(e) => handleOrderDetailChange('tax', parseFloat(e.target.value) || 0)}
                                className="w-full text-sm p-2 pl-8 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                placeholder="0"
                              />
                              <div className="flex gap-2 mt-2">
                                {[3, 5, 12, 18, 28].map(percent => (
                                  <button
                                    key={percent}
                                    type="button"
                                    onClick={() => handleOrderDetailChange('tax', percent)}
                                    className={`text-xs px-2 py-1 rounded ${
                                      orderDetails.tax === percent
                                        ? 'bg-blue-100 text-blue-700'
                                        : 'bg-gray-100 hover:bg-gray-200'
                                    }`}
                                  >
                                    {percent}%
                                  </button>
                                ))}
                              </div>
                            </div>
                            <div className="relative">
                              <input
                                type="text"
                                value={orderDetails.tax_description || ''}
                                onChange={(e) => {
                                  if (e.target.value.length <= 60) {
                                    handleOrderDetailChange('tax_description', e.target.value);
                                  }
                                }}
                                maxLength={60}
                                className="w-full text-xs pr-10 py-2 pl-4 border border-gray-200 rounded focus:outline-none focus:ring-1 focus:ring-blue-200 mt-2"
                                placeholder="Description (optional)"
                              />
                              <div className="absolute right-2 bottom-1 text-xs text-gray-400">
                                {orderDetails.tax_description?.length || 0}/60
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      )}
                    </div>
                  </div>
                  {/* Template Preview */}
                  <div
                    className={`w-[28%] h-[58vh]`}
                    style={{ transform: "translate(0px, -35px)" }}
                  >
                    {selectedTemplate ? (
                      // <TemplatePreview data={selectedTemplate} drawerType='medium' />
                      <TemplatePreview
                        header={header}
                        headerVariable={headerVariable}
                        body={body}
                        bodyVariables={bodyVariables}
                        footer={footer}
                        buttons={buttons}
                        buttonsOrder={buttonsOrder}
                        ctaButtons={ctaButtons}
                        customButtons={customButtons}
                        selectedTemplate={selectedTemplate}
                        useTemplates={useTemplates}
                        drawerType="medium"
                        carousel={carousel}
                        authentication={authentication}
                        category={selectedTemplate?.subcategory_type}
                        data={selectedTemplate}
                        products={products}
                        orderDetails={orderDetails}
                      />
                    ) : (
                      <div className="w-full h-full bg-[var(--BG-25)] flex items-center justify-center rounded-[1vw]">
                        <NoData
                          contentClassName={"max-w-[65%]"}
                          icon={ICONS?.NoTemplateSelected}
                          content={"No template is selected for preview"}
                        />
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div
                  className={`w-full h-full overflow-hidden overflow-y-scroll`}
                  id="scrollableDiv"
                  ref={templateListContainerRef}
                >
                  {templates?.length > 0 ? (
                    <InfiniteScroll
                      dataLength={templates?.length}
                      next={() => {
                        loadNextPage();
                      }}
                      hasMore={templates?.length < count}
                      scrollableTarget="scrollableDiv"
                      height={isLoadingNextPage ? "53vh" : "58vh"}
                      className="w-full !pr-[0.2vw] listScroll grid md:grid-cols-3 grid-cols-2 flex-1 gap-x-10 gap-y-5"
                    >
                      {templates?.map((t) => {
                        return (
                          <div className="w-100  py-[0.5vw]  last:pb-[0.1vw] flex-row">
                            <TemplateCard
                              data={t}
                              selected={
                                t?.message_template_id ===
                                  selectedTemplate?.message_template_id &&
                                t?.name === selectedTemplate?.name &&
                                t?.language === selectedTemplate?.language &&
                                t?.category === selectedTemplate?.category
                              }
                              handlePreviewSelect={(value) => {
                                setSearchKey("");
                                setSelectedTemplate(value);
                              }}
                              useTemplate={() => setUseTemplates(true)}
                              className={"hover:bg-slate-100"}
                              previewSelect="previewSelectInbox"
                              useThisTemplate="useThisTemplateInbox"
                              header={header}
                              headerVariable={headerVariable}
                              body={body}
                              bodyVariables={bodyVariables}
                              selectedTemplate={selectedTemplate}
                              useTemplates={useTemplates}
                              carousel={carousel}
                              authentication={authentication}
                              category={selectedTemplate?.subcategory_type}
                            />
                          </div>
                        );
                      })}
                      {isLoadingNextPage && (
                        <div className="w-full h-[5vh] flex items-center justify-center">
                          <Loader Width={30} Height={30} loaderBg="white" />
                        </div>
                      )}
                    </InfiniteScroll>
                  ) : (
                    <div className="h-auto flex justify-center mt-20 pt-20">
                      <div className="flex-row h-10 mt-20">
                        <img
                          src={ICONS?.emptySearch}
                          alt="emptySearch"
                          className="w-14"
                        />
                        <div className="flex-column gap-3 pl-10">
                          <span className="new-header3 ">
                            Sorry, there are no matching results
                          </span>
                          <span className="no-search-body">
                            Use different filters or{" "}
                            <span
                              className="text-[#6940F2] pointer"
                              onClick={() => {
                                setSearchKey("");
                              }}
                            >
                              reset to default.
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {useTemplates && (
            <div
              className={`w-full  flex items-center justify-end gap-[0.6vw] ${
                isSending ? "cursor-not-allowed" : "cursor-pointer"
              }`}
            >
              <button
                // className={` px-[0.5vw] py-[0.3vw] rounded-[0.37vw] ${
                //   !creditsLow()
                //     ? "bg-[var(--primary)] text-[var(--white)] button-title"
                //     : "disable-button cursor-not-allowed"
                // }`}
                className={`button-title px-[0.5vw] py-[0.3vw] rounded-[0.37vw] ${isSending || (currentCategory() === "ORDER_DETAIL" && (!products || !products.some(p => p.id && p.id !== ''))) ? 'opacity-50 cursor-not-allowed' : 'bg-[var(--primary)] text-[var(--white)]'}`}
                onClick={() => {
                  // if (!isSending && !creditsLow()) {
                  if (!isSending) {
                    let datas = null;

                    if (currentCategory() === "CAROUSEL") {
                      const cardsObject = carousel?.cards?.map((card) => {
                        const key = card?.name
                          ?.replaceAll(" ", "_")
                          ?.toLowerCase();

                        return { key: `${key}_media`, value: card?.image };
                      });

                      const covertIntoSingleObject = Object.fromEntries(
                        cardsObject.map((item) => [item?.key, item?.value])
                      );

                      datas = {
                        bodyVariables: carousel?.bodyVariables || [],
                        headerVariable: custom?.bodyVariables || [],
                        ...covertIntoSingleObject,
                      };
                    } else {
                      datas = {
                        bodyVariables: custom?.bodyVariables || [],
                        headerVariable: [custom?.headerVariable] || [],
                      };

                      if (!["TEXT", "NONE"]?.includes(header?.format))
                        datas["media_url"] =
                          header?.example?.header_handle?.[0];
                    }

                    if (open) {
                      setOpenTemplateList(false);
                      setSelectTemplate(selectedTemplate);
                    }
                    if (sendTemplate)
                      sendTemplate({
                        ...datas,
                        message_template_id:
                          selectedTemplate?.message_template_id,
                        subcategory_type: selectedTemplate?.subcategory_type,
                        category: selectedTemplate?.category,
                        language: selectedTemplate?.language,
                        name: selectedTemplate?.name,
                        id: selectedTemplate?.id,
                        payment_details: {
                          products: products,
                          order_details: orderDetails,
                        }
                      });
                  }
                }}
                disabled={isSending || (currentCategory() === "ORDER_DETAIL" && (!products || !products.some(p => p.id && p.id !== '')))}
              >
                {isSending ? (
                  <div className="w-full flex items-center justify-center">
                    <Loader Width={120} Height={25} loaderBg="white" />
                  </div>
                ) : (
                  <>{open ? "Use Template" : "Submit Template"}</>
                )}
              </button>
            </div>
          )}
        </div>
      )}
      <input
        type="file"
        accept={
          header?.format === "IMAGE" || carousel?.header === "IMAGE"
            ? ".jpg, .png, .jpeg"
            : header?.format === "VIDEO" || carousel?.header === "VIDEO"
            ? ".mp4"
            : ".jpg, .png, .jpeg"
        }
        ref={inputRef}
        onChange={async (e) => {
          const res = await uploadFiles(
            e,
            header?.format || carousel?.header,
            null,
            {
              brand_id: currentBrand?.brand_id,
              template_id: id,
            }
          );

          if (res)
            await onDataChange({
              type: "carousel",
              updateKey: "update_card",
              id: selectedCard?.id,
              key: "image",
              value: res,
            });
        }}
        hidden
      />
    </div>
  );
}
